// Angular
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-modulo-seguridad-sidebar',
  templateUrl: './modulo-seguridad-sidebar.component.html',
  styleUrls: ['./modulo-seguridad-sidebar.component.scss']
})
export class ModuloSeguridadSidebarComponent implements OnInit {
  @Output() selecttab = new EventEmitter<String>();
  lstCategories=[
    {icon:'folder.png',name:'Seguridad', id:'seguridad'},
    {icon:'folder.png',name:'Seguridad SIB', id:2},
    {icon:'folder.png',name:'Reportes', id:3},
]
  constructor() { }

  ngOnInit(): void {
  }
  selectedtab(tab): void {
    this.selecttab.emit(tab)
  }
}
